module.exports = __webpack_public_path__ + "img/9.9f16e11a.png";